/* global utag, utag_data */

function getCookieRegion(cookieName) {
  var name = cookieName + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

window.tealiumLink = function(data) {
  let event_action = data.event_action
  if (
    typeof event_action === typeof undefined ||
    event_action === false
  ) {
    event_action = 'Clicked';
  }

  let event_category = data.event_category;
  if (
    typeof event_category === typeof undefined ||
    event_category === false
  ) {
    event_category = 'Interaction';
  }

  let event_type = data.event_type;
  if (
    typeof event_type === typeof undefined ||
    event_type === false
  ) {
    event_type = 'Button';
  }

  window.appEventData.push({
    "event":"Event",
    "eventInfo":[{
      "eventCategory":event_category,
      "eventAction":event_action,
      "eventLabel": data.site_interaction_link,
      "eventType": event_type,
      // "eventProductId":"KX2-TGGN"
    }]
  });

  if (window.intactDebug || jQuery('body').hasClass('user-logged-in')) {
    // eslint-disable-next-line no-console
    console.log(data);
    console.log(window.appEventData);
  }

  // window.appEventData.push({
  //   "event": "Page",
  //   "pageInfo": {
  //     "pageName": tealiumData.page_name,
  //     "pageCategory": tealiumData.page_type,
  //     "pageStep": "0.0",
  //     "pageProduct": tealiumData.page_type,
  //     "pageVersion": "Responsive",
  //     "loginStatus": "0",
  //     "pageBusinessLine": "Personal",
  //     "chatAvailability": "1",
  //     "pageLanguage": tealiumData.page_language,
  //     "pageProvince": tealiumData.cp.region,
  //   }
  // });

};
